<template lang="pug"> 
  v-card(flat tile)
    v-app-bar.overlay.no-padding( 
      fixed 
      extension-height='30'
    ) 
      template(v-if='marqueeStatus', #extension)
        div(@mouseenter='marqueePause=true' @mouseleave='marqueePause=false')
          marquee-text(:duration='marqueeSpeed' :paused='marqueePause')
            v-row(align='center')
              v-col
                div(v-html='marqueeText')          
      //- v-spacer
      //- router-link(:to='{ name:ROUTE_INDEX }', @click='GAmainbar(links[0].name )')
      //-   v-img(
      //-     max-width="100"
      //-     :src="imgLogo"
      //-   )
      v-app-bar-nav-icon(
        dark 
        @click.stop="expandNav"
      ) 
      router-link(:to='{ name:ROUTE_INDEX }', @click='GAmainbar(links[0].name )')
        #titlelogo
          v-img(v-if="isThaiCharoenPlus" width='50', src='@/assets/v3/logo-sd-tp.png')
          v-img(v-else-if="isSevenColor" width='100', src='')
          v-img(v-else-if="isThaisiam" width='100', src='@/assets/v3/logo-sd-ts.png')
          v-img(v-else-if="isHuaypromt" width='160', src='@/assets/v3/logo-hp.png')
          v-img(v-else-if="isJertjarat" width='80', src='@/assets/v3/logo-sd-jj.png')
          v-img(v-else-if="isLottoslot88" width='80', src='@/assets/v3/logo-sd-ls.png')
          v-img(v-else-if="isChokCharoen" width='120', src='@/assets/v3/logo-sd-cc.png')
          v-img(v-else-if="isBooncharern" width='120', src='@/assets/v3/logo-sd-bc.png')
          v-img(v-else-if="isCherdchai" width='100' src="@/assets/v3/logo-sd-cci-icon.png")
          v-img(v-else-if="isSapcharern" width='120' src="@/assets/v3/logo-sd-sc.png")
          v-img(v-else-if="isPacharern" width='100' src="@/assets/v3/logo-sd-pa.png")
          v-img(v-else width='100', src='@/assets/v3/logo-sd.png')
          //- h3.ml-2.white--text.font-weight-black
          //-   i.notranslate Huay
          //-   i.yellow--text.notranslate Insurance
    
      //- v-spacer
      //- v-btn(v-if='!isMobile' text x-small dark @click="openDepositNewTab")
      //-   v-icon(small) mdi-plus
      //-   h3 {{ $t('button.deposit') }}
      //- h5.white--text(v-if="isShowCreditText") {{ $t('remaining-credit') }}
      //- v-btn(text @click='refreshCredit()')
      //-   span.white--text.mx-1
      //-     h3 {{ wallet.amount }} ฿
      //-   v-icon(v-if='!walletLoading' color="white")  mdi-cached
      //-   v-icon(v-else color="white")  mdi-cached  mdi-spin

    nav-drawer(
      ref="sidebarRef" 
      :expand-status='expandStatus'
      :marquee-status='marqueeStatus'
    )
    dialog-select-external-game(
      ref='dialogselectexternalgameref'
      @loadCredit='creditInit'
    )

</template>
<script> 
import { filterTag } from '@/utils/filterString'   
import {
  news as apiMarquee, 
  service as apiExternal, 
  gameType as apiGameType 
} from '@/apis' 
import { FETCHMARQUEE, FETCHCREDIT } from '@/const/setTimeOutConfig' 
import { ROUTE_INDEX,ROUTE_DEPOSIT } from '@/const/route' 
import { menues } from '@/const/menues'
import NavDrawer from './NavDrawer-v3'
import dialogSelectExternalGame from '@/components/Dialog/DialogSelectExternalGame'
export default {
  components:{ 
    NavDrawer,
    dialogSelectExternalGame
  },  

  data: () => ({  
    marqueeText : null,
    marqueeArray : [],
    marqueeStatus : false, 
    marqueePause : false, 
    expandStatus:true,
    setTimeoutCredit: null,
    setTimeoutMarquee: null
  }),

  computed : {
    ROUTE_INDEX: () => ROUTE_INDEX,
    ROUTE_DEPOSIT: () => ROUTE_DEPOSIT,
    imgLogo () {
      return require('@/assets/nav/logo.svg')
    },
    links () {
      return this.$store.getters['sidebarItems/GETTERS_ITEMS']
    },
    isUserActive () {
      return this.$store.getters['appbar/GETTERS_USER_ACTIVE']
    },
    isMobile () {
      return !this.$vuetify.breakpoint.mdAndUp
    },
    isShowCreditText () {
      return this.$vuetify.breakpoint.smAndUp
    },
    externalgame () {
      return this.$store.getters['externalGame/GETTERS_EXTERNALGAME']
    },
    wallet () {
      return this.$store.getters['userProfile/GETTERS_WALLET']
    },
    walletLoading () {
      return this.$store.getters['userProfile/GETTERS_WALLET_STATUS']
    },
    isLogin () {
      return this.$store.getters['auth/GETTERS_TOKEN'] !== null
    },
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
    marqueeSpeed () { 
      return Math.round(this.marqueeText.length/10)
    },

    accessToken () {
      return this.$route.query.token
    },

    idTab () {
      return this.$store.getters['appbar/GETTERS_ID_TAB']
    },
    isTabActive () {
      return this.$store.getters['appbar/GETTERS_TAB_ACTIVE']
    },
  }, 

  watch : {
    // accessToken () {
    //   this.checkBoAccessToken()
    // }, 
    marqueeArray () {
      this.marqueeStatus = true
      setTimeout(()=>{
        this.marqueeStatus = false
      },120000) 
    },
  }, 

  async created () {
    if(this.isLogin){   
      await this.$store.dispatch('userProfile/ACTION_ME',true)
      await this.externalGameInit ()  
      // await this.checkCurrentGame ()
      await this.fetchMarquee ()
      await this.creditInit() 
      // this.checkBoAccessToken()
      // setInterval(()=>{this.fetchMarquee()},FETCHMARQUEE)
      // setInterval(()=>{this.creditInit()},FETCHCREDIT)

    } 

    this.setTimeoutMarquee = this.reloadMarquee()
    this.setTimeoutCredit = this.reloadCredit()

    window.addEventListener("storage", this.handleEventStore);
    window.addEventListener('blur', this.handleEventBlur);
    window.addEventListener('focus', this.handleEventFocus);
  }, 

  beforeDestroy () {
    clearTimeout(this.setTimeoutMarquee)
    clearTimeout(this.setTimeoutCredit)
    window.removeEventListener("storage", this.handleEventStore);
    window.addEventListener('blur', this.handleEventBlur);
    window.removeEventListener('focus', this.handleEventFocus);
  },

  methods:{
    openDepositNewTab () {
      const routeData = this.$router.resolve({
        name: ROUTE_DEPOSIT, 
      })
      window.open(routeData.href, '_blank')
    },
    handleEventStore (e) {
      //update storage to check in state
      const idLastActiveTab = e.storageArea['idLastActiveTab']

      const isTabActve = this.idTab === idLastActiveTab
      this.$store.commit('appbar/MUTATION_TAB_ACTIVE', isTabActve)
    },
    handleEventBlur () {
      this.$store.commit('appbar/MUTATION_USER_ACTIVE',false)
      this.$store.dispatch('appbar/ACTION_USER_ACTIVE')
    },
    handleEventFocus () {
      this.$store.commit('appbar/MUTATION_USER_ACTIVE',true)
      this.$store.commit('appbar/MUTATION_TAB_ACTIVE', true)
      this.$store.dispatch('appbar/ACTION_USER_ACTIVE')
      // this.checkCurrentGame() 
    },
    // checkBoAccessToken () { 
    //   if(this.accessToken) {
    //     localStorage.setItem('access-Token',this.accessToken) 
    //     this.$router.push({
    //       name:ROUTE_INDEX
    //     })
    //     window.location.reload()
    //   }
    // },
    reloadCredit () {
      setTimeout(()=> {
        this.creditInit ()
        this.reloadCredit()
      },FETCHCREDIT)

    },

    reloadMarquee () {
      setTimeout(()=> {
        this.fetchMarquee ()
        this.reloadMarquee()
      },FETCHMARQUEE)
    },
    async fetchMarquee () { 
      if(this.isLogin && this.isTabActive){  
        let reset = false 
        let type = { type:4 } 
        const [err,data ] =  await apiMarquee.getNews(type)

        if(err) {
          this.$alert('',err,'warning') 
          return
        }  
        
        if(data.length!==0) { 
          data.forEach(e=>{ 
            if(this.marqueeArray.find(x=>x.uuid===e.uuid)){
              e.count ? e.count+=1 : e.count = 0   
            } else {
              e.count = 0
              this.marqueeStatus = false
              this.marqueeArray.push(e)  
              reset = true 
            }
          }) 
        }

        if(reset) {  
          this.marqueeText = Array(Math.round(window.innerWidth/4)).fill('\xa0').join('') 
          this.marqueeArray.forEach(e=>{ 
            if(!e.count || e.count<=2 ){     
              this.marqueeText += `${e.title} : ${filterTag(e.description)} ${Array(Math.round(window.innerWidth/8)).fill('\xa0').join('')} `  
            } 
          })  
        }
      }
    },

    updateCloseExternalGame () {    
      const links = menues
      if(this.externalgame.find(x=>x.category_game_type_id===2)){
        links[2].Isclosed = false
      }
      if(this.externalgame.find(x=>x.category_game_type_id===3)){
        links[3].Isclosed = false
      }
      if(this.externalgame.find(x=>x.category_game_type_id===4)){ 
        links[4].Isclosed = false
      }
      if(this.externalgame.find(x=>x.category_game_type_id===5)){ 
        links[5].Isclosed = false
      }
      
      //check for coach list item
      if((this.userProfile || {}).coach){
         links[16].Isclosed = false 
         links[16].to = `${(this.userProfile.coach || {}).link}`
      }
 
      //fetch for component not update in file not yet
      this.$store.commit('sidebarItems/MUTATION_ITEMS',links)
    },

    async checkCurrentGame () {     
      if(this.isLogin) {  
        const [err,data ] =  await apiExternal.getCurrentGame()
         
        if(err) {
          this.$alert('',err,'warning') 
          return
        }   
        if(data.length !== 0 ) {  
          this.$refs.dialogselectexternalgameref.openDialog(data) 
        } 
      }
    }, 

    async externalGameInit (params = {}) {
      params.scope = 'external' 
        
      const [err,data ] = await apiGameType.get(params)
      
      if(err) { 
        return
      }   

      //filter closed game here !!!
      
      this.$store.commit('externalGame/MUTATION_EXTERNALGAME',data)   
      this.updateCloseExternalGame()  
    },

    async creditInit () {  
      if(this.isLogin && this.isTabActive){    
        this.$store.dispatch('userProfile/ACTION_WALLET') 
      }
    },  

    expandNav () {    
      this.$ga.event('Button', 'ExpandSidebar', 'SideBar-V2','' ) 
      this.$refs.sidebarRef.openSideBar()
    },

    GAmainbar (name){
      this.$ga.event('Button', 'SelectPage', 'MainBar-V2',name )
    },

    refreshCredit (){ 
      this.$ga.event('Button', 'RefreshWallet', 'MainBar-V2','' ) 
      this.creditInit()
      // this.checkCurrentGame()
    },
  }
} 
</script>
<style scoped> 
#titlelogo {
  font-family: CooperHewitt !important;
  font-style: normal;
  margin: 0;  
  text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.700);
  transition: 200ms all;
  font-size: calc(1rem + 0.25vh);
} 
.overlay { 
  z-index: 80!important;  
  background-color:var(--bg-nav-main-color) !important;
  box-shadow: none !important;
}    
.no-padding >>> .v-toolbar__extension {
  padding: 0px !important;
  background-color: var(--bg-secondary-color);
}
</style>
